// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap');*/\r\n", "",{"version":3,"sources":["webpack://src/styles/MapFonts.css"],"names":[],"mappings":"AAAA,kGAAkG","sourcesContent":["/*@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap');*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
